module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fx radio-bar"
  }, _vm._l((_vm.listBar), function(item) {
    return _c('p', {
      staticClass: "fx fx-y-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.activeBarModel),
        expression: "activeBarModel"
      }],
      staticClass: "radio",
      attrs: {
        "type": "radio",
        "id": item.type,
        "name": "chack"
      },
      domProps: {
        "value": item.type,
        "checked": _vm._q(_vm.activeBarModel, item.type)
      },
      on: {
        "change": function($event) {
          _vm.activeBarModel = item.type
        }
      }
    }), _c('label', {
      attrs: {
        "for": item.type
      }
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-4822af30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/zui/RadioBar.vue
// module id = 838
// module chunks = 0